import { EntityDto, IEntityDto } from "../../../utils/models/entity-dto";
import { FieldType } from "@gbs-platform-client/fwk-core";

export class Designation extends EntityDto implements IEntityDto {
    Designation_Id: string;
    DesignationName: string;
    Designation_Level_Id: string;
    DesignationLevelName: string;
    Code:string;
    TotalCount: number;
    IsActive: boolean;

    constructor() {
        super();
        this.Designation_Id = "00000000-0000-0000-0000-000000000000";
        this.DesignationName = "";
        this.Designation_Level_Id = "";
        this.DesignationLevelName = "";
        this.Code ="";
        this.TotalCount = 0;
        this.IsActive = true;

        this.EntityMetaData = [
            { FieldName: 'DesignationName', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Name is required' },
            { FieldName: 'Code', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Code is required' },
            //{ FieldName: 'Designation_Level_Id', FieldType: FieldType.String, IsMandatory: true, ValidationMessage: 'Designation Level is required' },
        ];
    }
}
